module.exports = __webpack_public_path__ + "img/Cho.d1a6ac47.png";